var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWeather02N(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "56px",
    viewBox: "0 0 58 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-02n") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-02n",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4438345,5.30062139 C43.8647344,7.90736331 40.7914056,12.7257555 40.7914056,18.2388067 C40.7914056,25.0904557 45.5383613,30.8691587 52.0231999,32.6629096 C49.7214448,33.9732285 47.0392227,34.7247242 44.1756287,34.7247242 C35.6152151,34.7247242 28.6756287,28.0089955 28.6756287,19.7247242 C28.6756287,11.440453 35.6152151,4.72472424 44.1756287,4.72472424 C45.656005,4.72472424 47.0879093,4.92556317 48.4438345,5.30062139 Z",
    id: "Combined-Shape",
    stroke: "#373E42",
    fill: "#605F5E",
    strokeLinecap: "square",
    transform: "translate(40.349414, 19.724724) rotate(-28.000000) translate(-40.349414, -19.724724) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5907891,52.6448693 C39.8309353,54.1111468 37.5247323,55 35,55 C33.2981111,55 31.6955203,54.5961112 30.2926392,53.8837244 C28.5741534,55.2071151 26.3845442,56 24,56 C20.4859169,56 17.3951872,54.2780385 15.6117563,51.6738638 C14.0989892,52.5185976 12.3557134,53 10.5,53 C4.70101013,53 0,48.2989899 0,42.5 C0,37.533271 3.44847762,33.3719771 8.08171518,32.279836 C8.71205855,27.6094153 12.9123324,24 18,24 C19.9584984,24 21.7854969,24.534867 23.3279717,25.4592284 C26.0474464,22.7061027 29.8244824,21 34,21 C41.3021766,21 47.3856658,26.2178212 48.7254283,33.1284244 C53.9808939,33.9187338 58,38.261345 58,43.5 C58,49.2989899 53.0751322,54 47,54 C45.0337848,54 43.1880589,53.5075731 41.5907891,52.6448693 Z",
    id: "Combined-Shape-Copy-4",
    stroke: "#0A6EAC",
    fill: "#59A5D8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(29.000000, 38.500000) scale(-1, 1) translate(-29.000000, -38.500000) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeather02N);
export default __webpack_public_path__ + "static/media/icon-weather-02n.6918da46dfe4ff72649ea58f8af93581.svg";
export { ForwardRef as ReactComponent };